<template>
  <admin-layout>
    <template v-slot:breadcrumb>
      <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
        <li class="breadcrumb-item text-sm">
          <a class="opacity-5 text-white" href="javascript:;">Lojista</a>
        </li>
        <li class="breadcrumb-item text-sm text-white" aria-current="page">
          Serviço
        </li>
      </ol>
    </template>

    <template v-slot:header>
      <h5 class="font-weight-bolder text-white mt-4 mb-0">
        Registro do Serviço
      </h5>
    </template>

    <template #content>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header p-3 pb-0">
              <div class="row">
                <div class="col-8 d-flex">
                  <div class="d-flex flex-column justify-content-center"></div>
                </div>
                <div class="col-4">
                  <!--   <span class="badge bg-gradient-primary ms-auto float-end"
                    >Em análise</span
                  > -->
                </div>
              </div>
            </div>
            <div class="card-body p-3 pt-1">
              <div class="row p-4">
                <div class="col-sm-6">
                  <img
                    width="800"
                    height="600"
                    src="/assets/svg/wait.svg"
                    alt=""
                    class="img-fluid mx-auto d-block"
                  />
                </div>
                <div class="col-sm-6">
                  <div class="texto mt-5">
                    <span class="badge bg-gradient-primary">Em análise</span>
                    <h3 class="mt-2">
                      Estamos verificando o serviço cadastrado, caso esteja em
                      conformidade, será publicado em breve!
                    </h3>
                    <p class="text lead mt-3 pe-5">
                      Conferimos as informações inseridas para garantir o
                      cumprimento das nossas políticas e termos de serviço.
                    </p>

                    <Link
                      :href="route('admin.lojistas.servico')"
                      class="btn bg-gradient-primary mt-3 ms-auto"
                      >Acesse meu serviço</Link
                    >
                  </div>

                  <!--     <div class="d-flex bg-gray-100 border-radius-lg p-3">
                    <h4 class="my-auto">Meu Serviço</h4>
                    <Link
                      :href="route('admin.lojistas.servico')"
                      class="btn btn-outline-dark mb-0 ms-auto"
                      >Abrir</Link
                    >
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import { Link } from "@inertiajs/inertia-vue3";
export default {
  components: {
    AdminLayout,
    Link,
  },
};
</script>
